import { CHECKIN_ROUTES } from '@conf/routes.config';

/**
 * basic-page-layout l-containerのcolorを変更するURL
 */
export const CHANGE_CONTAINER_COLOR_URLS = [`/${CHECKIN_ROUTES.seatmap}`] as string[];
